import React from "react";
import PublicNav from "../components/public/PublicNav";
import PublicFooter from "../components/public/PublicFooter";
import "./PublicPage.css";

export default function ContactPublic() {
  return (
    <div className="public-page">
      <PublicNav />
      <main className="public-page__main">
        <section className="public-hero">
          <div className="public-hero__inner">
            <span className="public-hero__kicker">Contact</span>
            <h1 className="public-hero__title">
              Talk to Zyft
              <br />
              <span className="public-hero__accent font-serif">about your rollout</span>
            </h1>
            <p className="public-hero__subtitle">
              We will help you design a tenant-secure rollout, branding setup, and role model
              tailored to your organization.
            </p>
          </div>
        </section>

        <section className="public-section">
          <div className="public-section__inner public-contact">
            <div className="public-contact__card">
              <h2 className="public-h2">Sales</h2>
              <p className="public-p">Request a demo or discuss enterprise requirements.</p>
              <a className="public-link" href="mailto:sales@zyft.ai">
              <img src="/images/mail.png" alt="mail" className="mail-icon" />
              sales@zyft.ai</a>
            </div>

            <div className="public-contact__card">
              <h2 className="public-h2">Support</h2>
              <p className="public-p">For existing customers and platform questions.</p>
              <a className="public-link" href="mailto:support@zyft.ai">
              <img src="/images/mail.png" alt="mail" className="mail-icon" />
              support@zyft.ai</a>
            </div>

            <div className="public-contact__card">
              <h2 className="public-h2">Partnerships</h2>
              <p className="public-p">Explore integrations and partner programs.</p>
              <a className="public-link" href="mailto:partners@zyft.ai">
              <img src="/images/mail.png" alt="mail" className="mail-icon" />
              partners@zyft.ai</a>
            </div>
          </div>
        </section>
      </main>
      <PublicFooter />
    </div>
  );
}
